exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".rainfall__description[data-v-01c62702]{max-width:480px}", ""]);

